// extracted by mini-css-extract-plugin
export default {"postCreatePage":"_28aHP"};